import constants from "../../core/constants";

class Controller {
  constructor($injector, Events) {
    "ngInject";
    this.Events = Events;
    this.City = $injector.get("City");
    this.showNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
    this.updateLiveETAConfig = this.updateLiveETAConfig.bind(this);
    this.isLiveETADisabled = true;
  }

  updateLiveETAConfig() {
    const stationLatencyThreshold =
      this.stationLatencyThreshold * constants.fromMinToMilli;
    const stationLatencyNotificationThreshold =
      this.stationLatencyNotificationThreshold * constants.fromMinToMilli;
    this.City.putAction(this.cityId, "update_station_latency_threshold", {
      station_latency_threshold: stationLatencyThreshold,
      station_latency_notification_threshold: stationLatencyNotificationThreshold,
    }).$promise.then(
      () => {
        this.isLiveETADisabled = true;
        this.Events.emit(this.showNotificationEvent, {
          message: "Live ETA Configuration is updated successfully",
        });
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/liveEtaConfiguration/liveEtaConfiguration.controller.js